<template>
    <div class="lms__superadmin_auditlog_list_table">
        <component-table
            :labels="[
                {
                    key: 'eventType',
                    title: 'Event type',
                    type: 'string'
                },
                {
                    key: 'time',
                    title: 'Time',
                    type: 'string'
                },
                {
                    key: 'affectedObject',
                    title: 'Affected object',
                    type: 'string'
                },
                {
                    key: 'source',
                    title: 'Source',
                    type: 'string'
                },
                {
                    key: 'result',
                    title: 'Result',
                    type: 'string'
                },
                {
                    key: 'description',
                    title: 'Description',
                    type: 'string'
                }
            ]"
            :items="items"
            :component-table-item="LmsSuperadminAuditLogListTableItem"
            @emit-sort="handleSort"
            @emit-perform-get-items="emitPerformGetItems"
            @emit-empty-state-submit="handleEmit({ message: 'emit-empty-state-submit' })"
        />
    </div>
</template>

<script>
import LmsSuperadminAuditLogListTableItem from '@/components/lms/superadmin/audit-log/list/LmsSuperadminAuditLogListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  name: 'lms-superadmin-audit-log-list-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminAuditLogListTableItem
    }
  },
  props: {
    items: {
      type: Array
    },
    sortQueryable: {
      type: Boolean
    }
  },
  methods: {
    handleEmit (data) {
      const message = data.message
      const value = data.value
      this.$emit(message, value)
    },
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    emitPerformGetItems (data) {
      this.$emit('emit-perform-get-items')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/audit-log/_lmssuperadminauditloglisttable.scss";
</style>
